'use strict';
import React from 'react';
import flux from 'utils/flux';
import {Link} from 'react-router';
import SubmissionLink from '../header/submissionLink';

var Offcanvas = React.createClass({
    displayName: 'Offcanvas',

    mixins: [],

    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    propTypes: {
        isAuthenticated: React.PropTypes.bool,
        hasAcceptedLatestTerms: React.PropTypes.bool,
        activeBasketId: React.PropTypes.string,
        baskets: React.PropTypes.object
    },
    getInitialState() {
        return {
            licensingIsOpen: false,
            basketIsOpen: false,
            accountIsOpen: false
        };
    },
    renderSubmenu(isOpen, name) {
        if (isOpen) {
            return (
                <ul>
                    {this.props.baskets.map( basket => {
                        basket = basket.toJS();
                        return (
                            <li className="menu__item">
                                <Link onClick={this.closeSubMenu} to={name} params={{id: basket.id}}>
                                    {basket.name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            );
        }
    },
    closeSubMenu() {
        //this.setState(this.getInitialState());
    },
    renderAccountMenu() {
        const { userGuide } = flux.getStore('app').getState().config.toJS();
        const { accountEditable, passwordEditable } = flux.getStore('app').getState();
        if ( this.state.accountIsOpen ) {
            return (
                <ul>
                    {userGuide.length && <li><a href={userGuide} target="_blank">{flux.t('quick_start_guide')}</a></li>}
                    {false !== accountEditable && <li><Link to="accountDetails">{flux.t('account_details')}</Link></li>}
                    {false !== passwordEditable && <li><Link to="accountPassword">{flux.t('account_password_change_head')}</Link></li>}
                    <li><a href="/#/terms-of-use" target="_blank">{flux.t('terms-of-use')}</a></li>
                    <li><a href="http://gopro.com/privacy-policy" target="_blank">{flux.t('privacy')}</a></li>
                </ul>);
        }
    },
    openSubMenu(name, e) {
        e.preventDefault();
        if (name === 'licensing') {
            this.setState({licensingIsOpen: !this.state.licensingIsOpen});
        }
        if (name === 'basket') {
            this.setState({basketIsOpen: !this.state.basketIsOpen});
        }
        if (name === 'account') {
            this.setState({accountIsOpen: !this.state.accountIsOpen});
        }
    },
    logout(e) {
        e.preventDefault();
        flux.getActions('app').logout();
        flux.getStore('app').closeOffcanvas();
        this.context.router.transitionTo('login');
    },
    render() {
        if (!this.props.isAuthenticated) {
            return null;
        }
        const { activeBasketId } = this.props;
        const { config } = flux.getStore('app').getState();
        const { licensing, allowSubmissions } = config.toJS();
        return (
            <div className="offcanvas">
                <div className="offcanvas__logo">
                    <img src="images/logo.png"/>
                </div>

                {allowSubmissions && <div className="awards-button__wrapper"><SubmissionLink /></div>}

                <ul className="offcanvas__menu">
                    <li className="menu__item">
                        <Link to="listing" >
                            {flux.t('nav_home')}
                        </Link>
                    </li>
                    {licensing && <li className="menu__item">
                        <Link
                            onClick={this.openSubMenu.bind(null, 'licensing')}
                            to={activeBasketId ? 'singleLicensing' : 'licensing'}
                            params={{ id: activeBasketId }} >
                            {flux.t('nav_request_licence')}
                            <i className="gopro-play"></i>
                        </Link>
                        {this.renderSubmenu(this.state.licensingIsOpen, 'licensing')}
                    </li>}
                    {licensing && <li className="menu__item">
                        <Link to="requests">
                            {flux.t('nav_requests_license')}
                        </Link>
                    </li>}
                    <li className="menu__item">
                        <Link
                            onClick={this.openSubMenu.bind(null, 'basket')}
                            to={activeBasketId ? 'singleBasket' : 'basket'}
                            params={{ id: activeBasketId }} >
                            {flux.t('basket_selection')}
                            <i className="gopro-play"></i>
                        </Link>
                        {this.renderSubmenu(this.state.basketIsOpen, 'basket')}
                    </li>
                    <li className="menu__item">
                        <Link onClick={this.openSubMenu.bind(null, 'account')} to="account">
                            {flux.t('account_header_nav')}
                            <i className="gopro-play"></i>
                        </Link>
                        {this.renderAccountMenu()}
                    </li>
                    <li className="menu__item">
                        <a href="#" onClick={this.logout} title="Logout">
                            {flux.t('navigate_logout')}
                            <i className="gopro-log-out logout__icon" />
                        </a>
                    </li>
                    <li className="menu__item">
                        <Link to="help">
                            {flux.t('nav_help_me')}
                        </Link>
                    </li>
                </ul>
            </div>
        );
    }
});

module.exports = Offcanvas;



// WEBPACK FOOTER //
// ./app/components/offcanvas/offcanvas.jsx